module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opera-orderList"
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('orderList_title')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ordertop",
    class: {
      searchFix: _vm.searchPosition
    },
    style: ({
      top: _vm.searchTop
    })
  }, [_c('div', {
    staticClass: "search"
  }, [_c('i', {
    staticClass: "iconfont icon-sousuo"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchOption.searchText),
      expression: "searchOption.searchText"
    }],
    attrs: {
      "type": "text",
      "id": "seachContent",
      "name": "",
      "placeholder": _vm.$t('orderList_searchText_placeholder')
    },
    domProps: {
      "value": (_vm.searchOption.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchOption, "searchText", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchOption.searchText != ''),
      expression: "searchOption.searchText != ''"
    }],
    staticClass: "cleartext"
  }, [_c('i', {
    staticClass: "iconfont icon-cuowu",
    on: {
      "click": function($event) {
        _vm.searchOption.searchText = '';
        _vm.getOrderListNew()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "searchBtn",
    on: {
      "click": _vm.getOrderListNew
    }
  }, [_vm._v(_vm._s(_vm.$t('search')))])]), _vm._v(" "), _c('div', {
    staticClass: "oList"
  }, [_c('div', {
    staticClass: "tags clearfix",
    class: {
      posiTwo: _vm.fixedTwo
    },
    style: ({
      top: _vm.PosiTop
    })
  }, [_c('div', {
    staticStyle: {
      "width": "3000px"
    }
  }, [_c('div', {
    staticClass: "tag",
    class: {
      active: _vm.searchOption.index == 1
    },
    on: {
      "click": function($event) {
        return _vm.getList(1)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('orderList_notArr')) + "\n          (" + _vm._s(_vm.stateNum.notArr) + ")\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "tag",
    class: {
      active: _vm.searchOption.index == 23
    },
    on: {
      "click": function($event) {
        return _vm.getList(23)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('orderList_hasArr')) + "\n          (" + _vm._s(_vm.stateNum.hasArr) + ")\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "tag",
    class: {
      active: _vm.searchOption.index == 22
    },
    on: {
      "click": function($event) {
        return _vm.getList(22)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('orderList_notDep')) + "\n          (" + _vm._s(_vm.stateNum.notDep) + ")\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "tag",
    class: {
      active: _vm.searchOption.index == 24
    },
    on: {
      "click": function($event) {
        return _vm.getList(24)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('orderList_hasDep')) + "\n          (" + _vm._s(_vm.stateNum.hasDep) + ")\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "tag",
    class: {
      active: _vm.searchOption.index == 11
    },
    on: {
      "click": function($event) {
        return _vm.getList(11)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('orderList_allReserve')) + "\n          (" + _vm._s(_vm.stateNum.allReserve) + ")\n        ")])])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.getNextPage),
      expression: "getNextPage"
    }],
    staticClass: "list clearfix",
    attrs: {
      "infinite-scroll-disabled": "loading",
      "infinite-scroll-distance": "20"
    }
  }, [_vm._l((_vm.orderList), function(order, index) {
    return _c('li', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "detailed"
    }, [_c('div', {
      staticClass: "top clearfix"
    }, [_c('p', {
      staticClass: "left"
    }, [_vm._v(_vm._s(_vm.$t('orderList_rsvNo')) + "：" + _vm._s(order.rsvNo))])]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": _vm.link(order)
      }
    }, [_c('div', {
      staticClass: "content clearfix"
    }, [_c('ul', [_c('li', {
      staticClass: "info"
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('orderList_username')) + "：" + _vm._s(order.username) + "\n                ")]), _vm._v(" "), _c('li', {
      staticClass: "info"
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('orderList_mobile')) + "：" + _vm._s(order.mobile) + "\n                ")]), _vm._v(" "), _c('li', {
      staticClass: "info"
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('orderList_arr')) + "：" + _vm._s(_vm._f("dateF")(order.arr)) + "-" + _vm._s(_vm._f("dateF")(order.dep)) + "\n                ")]), _vm._v(" "), _c('li', {
      staticClass: "info"
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('orderList_rmnum')) + "：" + _vm._s(order.rmnum) + "\n                ")]), _vm._v(" "), _c('li', {
      staticClass: "info"
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('orderList_rmtype')) + "：" + _vm._s(order.rmtype) + "\n                ")]), _vm._v(" "), _c('li', {
      staticClass: "info"
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('orderList_realRate')) + "：\n                  "), _c('small', [_vm._v("￥")]), _vm._v("\n                  " + _vm._s(order.realRate) + "\n                ")]), _vm._v(" "), _c('li', {
      staticClass: "info"
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('orderList_member_no')) + "：" + _vm._s(order.member_no) + "\n                ")]), _vm._v(" "), _c('li', {
      staticClass: "info"
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('orderList_member_crpName')) + "："), _c('span', [_vm._v(_vm._s(order.crpName))])])]), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-you"
    })])])], 1)])
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loadingli"
  }, [_c('mt-spinner', {
    attrs: {
      "type": 2
    }
  })], 1), _vm._v(" "), _c('nothing', {
    attrs: {
      "condition": _vm.orderList != null && _vm.orderList.length == 0
    }
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasDx),
      expression: "hasDx"
    }],
    staticClass: "dx"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('loading_end_message')) + "\n      ")])], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-1fa6851a","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaPage/orderList.vue
// module id = 1749
// module chunks = 107